import React, { useEffect, useState } from 'react';
const backNews = '/icons/backNews.svg';
import styles from './SingleMagazinePage.module.scss';

const facebook = '/icons/socials/facebook2.svg';
const twitter = '/icons/socials/twitter2.svg';
const whatsapp = '/icons/socials/whatsapp_2_.svg';

import defaultImage from '../../../assets/images/defaultNews.png';
import { useNavigate, useParams } from 'react-router-dom';

import endpoints from '../../../api/endpoints';

import formatDate from '../../../app/helpers/formatedDate';
import Loader from '../../../components/atoms/loader/Loader';
import { useGetQuery } from '../../../services/apiCall';
import useIsRtl from '../../../app/helpers/isRtl';
import useScrollToTop from '../../../app/hooks/useScrollToTop';
import Text from '../../../components/atoms/text/Text';
import Footer from '../../../components/templates/homePageSections/footer/Footer';
import HeaderSection from '../../../components/organism/headerSection/HeaderSection';
import InnerButton from '../../../components/atoms/innerButton/innerButton';
import DOMPurify from 'dompurify';
import { successMessage } from '../../../components/atoms/toast/Toast';
const CopyLink = '/icons/copyLink.svg';

const Slide = ({ image }) => {
  const handleError = (e) => {
    e.target.src = defaultImage;
  };

  return (
    <div className={styles['image']}>
      <img className={styles['img']} src={image} alt="" onError={handleError} />
    </div>
  );
};
const getNormalizedContent = ({ data }) => {
  if (!data || data.length === 0) return {};

  const item = data[0];

  return {
    title: item.title_EN,
    subtitle: item.title_AR,
    date: item.magazineDate,
    image: `${item.url}${item.magazineThumbnail}`,
    description: '',
    file: `${item.url}${item.magazineBlob}`,
    edition: item.editionNumber,
    pageNumber: item.pageNumber,
    academicYearId: item.academicYearId,
  };
};
const SingleMagazinePage = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  useScrollToTop();
  const navigate = useNavigate();
  const { id: rawId } = useParams();
  const type = rawId?.split('-')[0];
  const id = rawId?.split('-').slice(1).join('-');
  const isRtl = useIsRtl();

  let apiUrl = `${endpoints.magazine.getMagazinesById}${id}`;

  const { data, error, isLoading, refetch } = useGetQuery({
    apiUrl: apiUrl,
  });

  useEffect(() => {
    refetch();
  }, []);

  const content = getNormalizedContent({ data });
  const magazineUrl = DOMPurify.sanitize(content?.file);

  const handleViewClick = () => {
    window.open(
      `/pdf-view?pdfUrl=${encodeURIComponent(magazineUrl)}`,
      '_blank'
    );
  };

  const handleDownloadClick = () => {
    setIsDownloading(true);
    //is was sanitized here
    const sanitizedUrl = DOMPurify.sanitize(magazineUrl, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    });

    try {
      new URL(sanitizedUrl);
    } catch (error) {
      console.warn('Invalid URL:', sanitizedUrl);
      return;
    }
    const fileName =
      content?.file?.split('/').pop() || 'Dubai-Police-Academy.pdf';
    fetch(sanitizedUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = DOMPurify.sanitize(url);
        link.download = `${'Dubai-Police-Academy'}-${fileName}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setIsDownloading(false);
      })
      .catch((error) => {
        setIsDownloading(false);
        console.error('Error downloading the PDF:', error);
      });
  };
  let title = '';
  if (type === 'magazine') {
    title = 'home.academy_echo_magazine';
  } else if (type === 'policies') {
    title = 'guideline.title_plural';
  } else {
    title = 'security_and_law.header_title';
  }
  return (
    <>
      <div className={styles['single-news-page']}>
        {isLoading && <Loader fullPage />}
        <div
          className={`${styles['page-header']} ${isRtl ? styles['header-rtl'] : ''}`}
        >
          <span className={styles['span']}>
            <img src={backNews} alt="" onClick={() => navigate(-1)} />
          </span>
          <Text
            title={title}
            variant="text-bold-25-black"
            color="#1a1a1a"
            className={styles.backTitle}
            isLineBreak
            style={{ direction: isRtl ? 'rtl' : '' }}
          />
        </div>

        <div className={styles['news-content']}>
          <div className={styles['news-description']}>
            <Text
              title={formatDate(content?.date)}
              variant="text-bold-italic-18"
              color="#1a1a1a"
              className={styles.date}
              style={{ direction: isRtl ? 'rtl' : '' }}
            />
            <Text
              title={content?.subtitle}
              variant="text-bold-italic-33"
              color="#1a1a1a"
              className={styles.text}
              style={{ direction: isRtl ? 'rtl' : '' }}
            />
            <div className={`${isRtl ? styles['num-rlt'] : ''} `}>
              <Text
                title={content?.pageNumber}
                variant="text-regular-16"
                color="#1a1a1a"
                className={styles.date}
              />{' '}
              <Text
                title={'common.pages'}
                variant="text-regular-16"
                color="#1a1a1a"
                className={styles.date}
              />
            </div>
          </div>
          <div className={styles['content-body']}>
            <div className={styles['carousel-container']}>
              <div className={`${styles['image-container']} `}>
                <Slide
                  image={content?.image}
                  className={styles['carousel-image']}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.actions}>
          <Text
            title={'common.pdfVersion'}
            variant="text-bold-italic-16"
            className={styles['infoText']}
            color="#1a1a1a"
          />
          <div className={styles.actionButtons}>
            <InnerButton
              title={'common.view'}
              style={{ width: '100%' }}
              onClick={handleViewClick}
            />
            <InnerButton
              title={'common.download'}
              style={{ width: '100%' }}
              onClick={handleDownloadClick}
              isLoading={isDownloading}
            />
          </div>
        </div>
        <div
          className={`${styles['footer']} ${isRtl ? styles['footer-rtl'] : ''}`}
        >
          <Text
            title="common.didYouLikeIt"
            variant="text-bold-italic-22"
            color="#1a1a1a"
            className={styles.shareText}
          />
          <div className={styles['social-media']}>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebook} alt="Share on Facebook" />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(`${content?.title}\n\n${window.location.href}`)}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={twitter} alt="Share on Twitter" />
            </a>
            <a
              href={`https://wa.me/?text=${encodeURIComponent(`${content?.title}\n\n${window.location.href}`)}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={whatsapp} alt="Share on WhatsApp" />
            </a>{' '}
            <button
              onClick={() => {
                navigator.clipboard.writeText(window.location.href);
                successMessage('common.copied_successfully');
              }}
              className={styles.copyButton}
            >
              <img src={CopyLink} alt="Copy Link" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleMagazinePage;
